module.exports = __webpack_public_path__ + "img/img-search06.e9e5c9f5.jpg";